import React, { useEffect } from 'react';
import ErrorMessage from '../../../../../assets/images/ads/error_message.png';
import successIcon from '../../../../../assets/images/ads/success_icon.svg';

const Toast = ({ message, time, className, success }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            const popup = document.querySelector('.custom_popup');
            if (popup) {
                popup.style.display = 'none';
            }
        }, time);

        return () => clearTimeout(timer);
    }, [time]);

    return (
        <>
            <div className={`custom_popup ${className}`}>
                <span>
                    <img src={success ? successIcon : ErrorMessage} className='icon' alt="status icon" />
                </span>
                <div>
                    <p className={`fw_500 ${success ? 'text_dark' : 'text_red'}`}>{message}</p>
                </div>
            </div>
        </>
    );
};

export default Toast;
